export default __webpack_public_path__ + "static/media/QS.f6fc4267.png";